import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FilterService from "../services/filter";

import { FilterKeyBoolean, FilterKeyNumber, FilterKeyString } from "../types";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type FilterStringProps = { code: FilterKeyString, onChange: () => void };
type FilterBooleanProps = { code: FilterKeyBoolean, onChange: () => void, icon: IconProp};
type FilterSelectNumberProps = { code: FilterKeyNumber, onChange: () => void, options: number[], all: number};
type FilterSelectStringProps = { code: FilterKeyString, onChange: () => void, options: string[], all: string};

type FilterProps = (FilterStringProps & {type: 'simple'})
                | (FilterStringProps & {type: 'comparator'})
                | (FilterStringProps & {type: 'date'})
                | (FilterBooleanProps & {type: 'switch'})
                | (FilterSelectNumberProps & {type: 'select-number'})
                | (FilterSelectStringProps & {type: 'select-string'})


type ChangeEvent = React.ChangeEvent<HTMLInputElement>;
type ChangeSelectEvent = React.ChangeEvent<HTMLSelectElement>;

function FilterSimple({code, onChange}: FilterStringProps) {
    return (
        <input
            value={FilterService.getString(code)}
            onChange={(event: ChangeEvent) => {
                FilterService.setString(code, event.target.value);
                if (onChange) {
                    onChange()
                }
            }}
            />
    );
}

function FilterComparator({code, onChange}: FilterStringProps) {
    return (
        <input
            value={FilterService.getString(code)}
            onChange={(event: ChangeEvent) => {
                FilterService.setString(code, event.target.value);
                if (onChange) {
                    onChange()
                }
            }}
            data-tooltip-id="info-filter"
            data-tooltip-content="Format : [<>=] Number; Exemple: <10, >50, =85, 52"
            data-tooltip-place="bottom"
            />
    );
}

function FilterDate({code, onChange}: FilterStringProps) {
    return (
        <input
            value={FilterService.getString(code)}
            onChange={(event: ChangeEvent) => {
                FilterService.setString(code, event.target.value);
                if (onChange) {
                    onChange()
                }
            }}
            data-tooltip-id="info-filter"
            data-tooltip-content="Format : [<>=] Date [Heure]; Exemple: <2022-05-11, >2024-06-28 11:58:00, =2023-12-31, 2021-01-01"
            data-tooltip-place="bottom"
            />
    );
}

function FilterBoolean({code, icon, onChange}: FilterBooleanProps) {
    return (
        <span
            className={"" + (FilterService.getBoolean(code) ? 'active' : 'inactive')}
            onClick={() => {
                FilterService.switchFilter(code);
                if (onChange) {
                    onChange()
                }
            }}
            >
            <FontAwesomeIcon icon={icon} size="2xs" />
        </span>
    );
}

function FilterSelectString({code, options, all, onChange}: FilterSelectStringProps) {
    return (
        <select
            onChange={(event: ChangeSelectEvent) => {
                FilterService.setString(code, event.target.value);
                if (onChange) {
                    onChange()
                }
            }}
            value={FilterService.getString(code)}>
            { options.map(option =>
                <option key={option} value={option}>{option === all ? 'Tous' : '' + option}</option>
            )}
        </select>
    );
}

function FilterSelectNumber({code, options, all, onChange}: FilterSelectNumberProps) {
    return (
        <select
            onChange={(event: ChangeSelectEvent) => {
                FilterService.setNumber(code, event.target.value);
                if (onChange) {
                    onChange()
                }
            }}
            value={FilterService.getNumber(code)}>
            { options.map(option =>
                <option key={option} value={option}>{option === all ? 'Tous' : '' + option}</option>
            )}
        </select>
    );
}

export default function Filter(props: FilterProps) {
    return props.type === 'simple' ? FilterSimple(props)
        :  props.type === 'comparator' ? FilterComparator(props)
        :  props.type === 'date' ? FilterDate(props)
        :  props.type === 'switch' ? FilterBoolean(props)
        :  props.type === 'select-string' ? FilterSelectString(props)
        :  props.type === 'select-number' ? FilterSelectNumber(props)
        :  null;
}